export default {"src":"/_next/static/media/mdi_spotify.ff3c9540.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};